import { create } from 'zustand';
import { api, sessionEvents } from '@/api/client';
import type { SessionUser } from '@/api/types';

type State = {
  status: 'loading' | 'authed' | 'anon' | 'expired' | 'error';
  user: SessionUser | null;
  error?: string;
  load: () => Promise<void>;
  can: (...perms: string[]) => boolean;
};

export const useSession = create<State>((set, get) => ({
  status: 'loading',
  user: null,
  async load() {
    try {
      const user = await api.get<SessionUser | null>('/api/auth/me');
      set({ user, status: user ? 'authed' : 'anon', error: undefined });
    } catch (e) {
      set({ status: 'error', error: e instanceof Error ? e.message : String(e) });
    }
  },
  /** 满足任意一个权限码即可 */
  can(...perms) {
    const p = get().user?.permissions || [];
    return perms.some((x) => p.includes(x));
  },
}));

// 接口返回 401 → 会话过期：保留当前页面，弹出重新登录引导
sessionEvents.addEventListener('expired', () => {
  if (useSession.getState().status === 'authed') useSession.setState({ status: 'expired' });
});
